<template>
    <div>
        <div
            class="relative flex items-center justify-between max-w-lg md:max-w-2xl lg:max-w-3xl mx-auto lg:mb-12"
        >
            <div class="hidden sm:block absolute top-0 p-6 w-full z-0">
                <div class="w-full border-t-2 border-dashed border-grey"></div>
            </div>
            <button
                v-for="step in 6"
                :key="step"
                class="z-10 text-center relative focus:outline-none"
                @click="activeStep = step"
            >
                <span
                    :class="{
                        'bg-orange': activeStep !== step,
                        'bg-teal-darker': activeStep === step,
                    }"
                    class="text-white text-lg  md:text-2xl font-semibold w-10 sm:w-12 h-10 sm:h-12 rounded-full flex items-center justify-center"
                >
                    {{ step }}
                </span>
                <span
                    :class="{ 'text-teal-darker': activeStep === step }"
                    class="hidden lg:block absolute top-0 w-32 pt-16 -mx-10 text-lg font-semibold"
                    v-html="carouselTitles[step - 1]"
                ></span>
            </button>
        </div>
        <div class="container max-w-7xl py-12 md:py-20 text-xl">
            <Transition name="slide-fade" mode="out-in">
                <div
                    v-if="activeStep === 1"
                    :key="1"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            viewBox="0 0 512.13 225.52"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g fill="none" stroke-width="3">
                                <circle
                                    cx="433.64"
                                    cy="70.04"
                                    r="46.85"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m433.64 58.92v165.1"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m415.2 78.72a18.44 18.44 0 1 0 36.87 0"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <circle
                                    cx="479.51"
                                    cy="168.12"
                                    r="22.01"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m479.51 166.36v57.66"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m470.08 168.12a9.43 9.43 0 0 0 18.86 0"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m175.07 224h-67.54a4 4 0 0 1 -4-4v-139.12h75.49v139.12a4 4 0 0 1 -3.95 4z"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m95.61 80.88h91.38"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m159.18 80.88h-35.75v-7.94a4 4 0 0 1 4-4h27.81a4 4 0 0 1 4 4z"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m141.3 96.78v110.48"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m159.18 96.78v110.48"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m123.43 96.78v110.48"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m512.13 223.9h-512.13"
                                    stroke="#0082cb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m25.94 211.81c-1.11-5.43.15-12.64 10.89-16.34 11.75-4.05 26.75 2.48 30.4 3.72-1.91 2.86-10.5 17.81-22.23 21.86-10.8 3.73-16.15-1.35-18.13-6.33a22.81 22.81 0 0 1 -.93-2.91z"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m58.81 201.72c-11.36-1.35-25.7 8.05-32.89 11.44"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m25.92 213.16s-3.35 2.2-9.64 2.92"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <g stroke="#0082cb">
                                    <path
                                        d="m224.26 186.94-7.19.55.67-182.11a3.61 3.61 0 1 1 7.19-.55z"
                                    />
                                    <path d="m211.2 197.57 22-1.66" />
                                    <path
                                        d="m243.12 213.24c-5.46 10.25-33.62 15-47-.07 13.91-7.66 16.68-18.94 17.23-23.44a2.41 2.41 0 0 1 2.2-2.13l10.8-.82a2.44 2.44 0 0 1 2.27 1.2z"
                                    />
                                    <path
                                        d="m209.76 209.16a25.88 25.88 0 0 1 -7.82 8.87"
                                    />
                                    <path
                                        d="m214.5 214a24.41 24.41 0 0 1 -5.09 7.33"
                                    />
                                    <path
                                        d="m220.89 215.35a23.78 23.78 0 0 1 -1.76 7.42"
                                    />
                                    <path
                                        d="m233.05 208.25a25.63 25.63 0 0 1 3.79 10.68"
                                    />
                                    <path
                                        d="m227.39 211.83a25 25 0 0 1 1.18 10"
                                    />
                                    <path
                                        d="m317.28 213.59h86.81v10.43h-86.81z"
                                    />
                                    <path
                                        d="m325.53 213.21 27.83-94.53a8.32 8.32 0 0 1 15.34 0l26.8 94.53"
                                    />
                                    <path d="m344.52 147.31h31.33" />
                                    <path d="m343.72 156.09h34.62" />
                                    <path d="m337.45 168.79h45.34" />
                                    <path d="m336.29 177.58h50.09" />
                                    <path
                                        d="m272.28 197.78.72-163.41a3.61 3.61 0 1 1 7.19-.54v164"
                                    />
                                    <path
                                        d="m256.34 220.21v-6.48a6 6 0 0 1 6-6h27.73a6 6 0 0 1 6 6v6.48"
                                    />
                                    <path d="m264.77 207.73v12.48" />
                                    <path d="m272.81 207.73v12.48" />
                                    <path d="m280.85 207.73v12.48" />
                                    <path d="m288.89 207.73v12.48" />
                                    <path
                                        d="m268.75 197.57h14.93v9.11h-14.93z"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[0]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold"
                            v-html="carouselBodies[0]"
                        ></div>
                    </div>
                </div>
                <div
                    v-else-if="activeStep === 2"
                    :key="2"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            viewBox="0 0 512.13 207.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g fill="none" stroke-width="3">
                                <path
                                    d="m512.13 142.31h-512.13"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m512.13 94.31h-512.13"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m159.44 142.31v-19.9a9 9 0 0 1 9.05-9h153.32a9 9 0 0 1 9 9v19.9"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m347.23 141.55 19.12 58.29h-240.07l19.12-58.29"
                                    stroke="#b0e7fb"
                                    stroke-miterlimit="10"
                                />
                                <path
                                    d="m170.46 52.17h-18.1l11.35-43.84h15.89z"
                                    stroke="#0082cb"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="m211.54 52.17h-18.1l6.32-43.84h15.89z"
                                    stroke="#0082cb"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="m252.62 52.17h-18.11l1.3-43.84h15.89z"
                                    stroke="#0082cb"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="m293.69 52.17h-18.1l-3.73-43.84h15.89z"
                                    stroke="#0082cb"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="m323.81 8.33h-15.89l8.74 43.84h18.11z"
                                    stroke="#0082cb"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <g stroke-miterlimit="10">
                                    <path
                                        d="m22.31 195.07c-1.11-5.43.16-12.64 10.89-16.34 11.76-4 26.75 2.48 30.41 3.72-1.92 2.86-10.5 17.81-22.25 21.87-10.81 3.68-16.16-1.32-18.13-6.32a22.85 22.85 0 0 1 -.92-2.93z"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m55.19 185c-11.37-1.37-25.71 8-32.89 11.42"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m22.3 196.42s-3.35 2.2-9.64 2.92"
                                        stroke="#b0e7fb"
                                    />
                                    <g opacity=".4" stroke="#0082cb">
                                        <path
                                            d="m480.68 84.48c-1.57 4.64-5.73 9.58-15.57 7.64-10.77-2.12-19.33-13.76-21.56-16.33 2.73-1.33 15.92-8.94 26.69-6.82 9.9 2 11.73 8.2 11 12.89a21.54 21.54 0 0 1 -.56 2.62z"
                                        />
                                        <path
                                            d="m451.1 77.59c8.08 6.08 23.2 5.27 30.18 5.87"
                                        />
                                        <path
                                            d="m481.28 83.46a20.88 20.88 0 0 1 8.66 2"
                                        />
                                    </g>
                                    <path
                                        d="m126.55 64.43v138.73"
                                        stroke="#0082cb"
                                        stroke-dasharray="8 8"
                                    />
                                    <path
                                        d="m367.18 64.43v138.73"
                                        stroke="#0082cb"
                                        stroke-dasharray="8 8"
                                    />
                                    <path
                                        d="m145.04 67.43v74.88"
                                        stroke="#0082cb"
                                        stroke-dasharray="8 8"
                                    />
                                    <path
                                        d="m347 67.43v74.88"
                                        stroke="#0082cb"
                                        stroke-dasharray="8 8"
                                    />
                                    <circle
                                        cx="36.39"
                                        cy="32.17"
                                        r="23.73"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m27.16 41.75 19.16-19.16"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m46.32 41.75-19.16-19.16"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m125.11 59.8h240.07l-19.12-58.3h-199.71z"
                                        stroke="#0082cb"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[1]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold mb-6"
                            v-html="carouselBodies[1]"
                        ></div>
                    </div>
                </div>
                <div
                    v-else-if="activeStep === 3"
                    :key="3"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            viewBox="0 0 512.13 196.52"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g stroke-width="3">
                                <g fill="none">
                                    <path
                                        d="m87.27 193c-.26-9.42 8.73-18 18.14-17.36 1.06-7.86 11.91-12.32 18.19-7.48-.3-6.63.34-13.95 5-18.64s14.53-4 16.26 2.41a10.27 10.27 0 0 1 19.92 4.82c3.68-3.13 8.14-5.81 13-5.68s9.76 4.1 9.41 8.92a7.43 7.43 0 1 1 12.53 7.73 10.69 10.69 0 0 1 14.63 13.63 6.78 6.78 0 0 1 7.43 11.09"
                                        stroke="#b0e7fb"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="m512.13 194.91h-512.13"
                                        stroke="#0082cb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m25.94 182.82c-1.11-5.43.15-12.64 10.89-16.34 11.75-4 26.75 2.47 30.4 3.71-1.91 2.87-10.5 17.81-22.23 21.87-10.8 3.73-16.15-1.35-18.13-6.34a22.67 22.67 0 0 1 -.93-2.9z"
                                        stroke="#b0e7fb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m58.81 172.73c-11.36-1.35-25.7 8.05-32.89 11.43"
                                        stroke="#b0e7fb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m25.92 184.16s-3.35 2.21-9.64 2.93"
                                        stroke="#b0e7fb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m317.28 184.6h86.81v10.43h-86.81z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m325.53 184.22 27.83-94.54a8.32 8.32 0 0 1 15.34 0l26.8 94.54"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m344.52 118.32h31.33"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m343.72 127.1h34.62"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m337.45 139.8h45.34"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m336.29 148.58h50.09"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m272.28 168.79.72-163.41a3.61 3.61 0 1 1 7.19-.55v164"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m256.34 191.21v-6.47a6 6 0 0 1 6-6h27.73a6 6 0 0 1 6 6v6.47"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m264.77 178.73v12.48"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m272.81 178.73v12.48"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m280.85 178.73v12.48"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m288.89 178.73v12.48"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m268.75 168.58h14.93v9.11h-14.93z"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="38.35"
                                        cy="49.73"
                                        r="23.73"
                                        stroke="#0082cb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m52.01 40.09-18.66 18.67-9.06-9.06"
                                        stroke="#0082cb"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="m135.92 32.84h2.15v-20.22a2.25 2.25 0 1 1 4.5-.14v10.42 10h1.56v-.58q0-6.48 0-13a2.24 2.24 0 0 1 4.48-.12v10.32 9.91.31c.18-.21.3-.35.4-.49 1.25-1.77 2.49-3.55 3.75-5.31a2.56 2.56 0 0 1 4.57 2.06 4.77 4.77 0 0 1 -.76 1.35c-2.42 3.43-4.87 6.85-7.28 10.28a1.68 1.68 0 0 0 -.28 1c.16 5.37.33 14.33.52 19.71q.28 8.63.59 17.25c.09 2.51.19 5 .27 7.53 0 .69-.08.79-.77.79h-28.62c-.72 0-.83-.1-.77-.82.29-3.43.59-6.85.87-10.28q.38-4.45.73-8.92t.74-8.72l.81-9.74c.43-5.19.81-10.39 1.3-15.58.39-4.13.61-8.26.63-12.4 0-2.39 0-4.79 0-7.18a2.26 2.26 0 0 1 3.08-2.17 2.22 2.22 0 0 1 1.43 2.13v8.8 3.77h1.54v-.71c0-5.58 0-11.15 0-16.73a2.3 2.3 0 0 1 1-2.07 2.14 2.14 0 0 1 2.4-.11 2.11 2.11 0 0 1 1.13 2v17.66z"
                                        stroke="#0082cb"
                                    />
                                </g>
                                <path
                                    d="m171.48 45.2 2 .75.2-.52 6.91-18.43a2.26 2.26 0 1 1 4.27 1.46l-3.66 9.75q-1.63 4.38-3.28 8.75l-.21.57 1.46.55.2-.55q2.28-6.06 4.55-12.13a2.25 2.25 0 0 1 4.25 1.46c-1.2 3.22-2.42 6.44-3.62 9.66-1.57 4.22-1.88 5.08-3.45 9.29 0 .06 0 .12-.07.3.24-.14.4-.22.55-.32 1.79-1.22 3.57-2.45 5.37-3.66a2.29 2.29 0 0 1 3.34.73 2.26 2.26 0 0 1 .13 2.8 4.62 4.62 0 0 1 -1.19 1c-3.47 2.37-7 4.71-10.43 7.08a1.8 1.8 0 0 0 -.59.79c-1.73 5.09-4.71 13.54-6.43 18.64q-2.76 8.17-5.5 16.36-1.18 3.57-2.38 7.14c-.22.66-.36.72-1 .47l-26.8-10c-.68-.25-.74-.38-.43-1q2.21-4.67 4.42-9.32l3.81-8.1 3.75-7.91 4.17-8.83c2.23-4.72 4.41-9.45 6.69-14.14 1.82-3.73 3.47-7.51 4.94-11.39.84-2.24 1.7-4.47 2.57-6.71a2.27 2.27 0 0 1 3.65-.95 2.24 2.24 0 0 1 .59 2.5l-3.09 8.25c-.44 1.17-.88 2.34-1.33 3.56l1.44.54.25-.66q2.94-7.83 5.87-15.67a2.33 2.33 0 0 1 1.63-1.6 2.18 2.18 0 0 1 2.29.74 2.15 2.15 0 0 1 .37 2.25q-1.92 5.13-3.85 10.26l-2.19 5.86z"
                                    fill="#fff"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m182.37 13.56v-12.06"
                                    fill="none"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m196.34 20.62 8.07-8.07"
                                    fill="none"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m202.01 34.34h11.82"
                                    fill="none"
                                    stroke="#0082cb"
                                />
                            </g>
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[2]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold mb-6"
                            v-html="carouselBodies[2]"
                        ></div>
                    </div>
                </div>
                <div
                    v-else-if="activeStep === 4"
                    :key="4"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            viewBox="0 0 512.13 181.09"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g fill="none" stroke-width="3">
                                <g stroke-miterlimit="10">
                                    <circle
                                        cx="437.97"
                                        cy="103.53"
                                        r="23.42"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m437.97 97.96v82.56"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m428.75 107.87a9.22 9.22 0 1 0 18.44 0"
                                        stroke="#b0e7fb"
                                    />
                                    <circle
                                        cx="460.91"
                                        cy="152.57"
                                        r="11"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m460.91 151.69v28.83"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m456.19 152.57a4.72 4.72 0 0 0 9.43 0"
                                        stroke="#b0e7fb"
                                    />
                                    <path
                                        d="m512.13 179.59h-512.13"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m60.88 172.59h26.04"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m50.87 160.58a6 6 0 0 0 -6 6 6 6 0 0 0 6 6"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="55.88"
                                        cy="173.6"
                                        r="5.01"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="55.88"
                                        cy="173.6"
                                        r="1"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="91.93"
                                        cy="173.6"
                                        r="1"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="91.93"
                                        cy="173.6"
                                        r="5.01"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m50.87 160.58a9.2 9.2 0 0 0 5.43-1.77l6-4.33a10 10 0 0 1 5.89-1.91h7.9a10 10 0 0 1 5.32 1.52c1.72 1.08 4.41 2.78 8.22 5.23a12.54 12.54 0 0 0 4.72 1.82l4.84.81a4.53 4.53 0 0 1 3.79 4.48v2.16a4 4 0 0 1 -4 4h-2"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m223.24 30.64h55.54v148.45h-55.54z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m278.79 83.12h23.39v95.97h-23.39z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m264.17 163.01v16.07"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m234.94 163.01h32.15"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m237.86 179.08v-16.07"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m251.02 163.01v16.07"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m232.01 97.23h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m246.63 97.23h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m261.25 97.23h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m232.01 113.31h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m246.63 113.31h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m261.25 113.31h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m232.01 129.39h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m246.63 129.39h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m261.25 129.39h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m232.01 145.47h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m246.63 145.47h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m261.25 145.47h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m286.1 129.39h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m286.1 145.47h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m286.1 161.54h8.77v8.77h-8.77z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 144.93h49.8"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 154.89h49.8"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m222.94 179.09v-79.69h-5.7-49.8-5.69v51.79"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m161.75 179.08v-17.64"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 179.09v-74h49.8v74"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 90.86h49.81v8.54h-49.81z"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 115.05h49.8"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 125.01h49.8"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 134.97h49.8"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m167.44 164.85h49.8"
                                        stroke="#0082cb"
                                    />
                                    <circle
                                        cx="153.21"
                                        cy="156.32"
                                        r="9.96"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m153.21 156.32v22.76"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m157.48 156.32a4.27 4.27 0 0 1 -8.54 0"
                                        stroke="#0082cb"
                                    />
                                    <path
                                        d="m161.75 112.26h-18.5v-51.43h-52.95v98.41"
                                        stroke="#0082cb"
                                    />
                                </g>
                                <path
                                    d="m358 179.13a5.39 5.39 0 0 1 5.53-5.3 3.64 3.64 0 0 1 5.54-2.27c-.09-2 .11-4.26 1.54-5.69s4.43-1.22 4.95.74a3.13 3.13 0 0 1 6.08 1.47 6 6 0 0 1 3.95-1.73 2.83 2.83 0 0 1 2.87 2.71 2.26 2.26 0 1 1 3.82 2.36 3.26 3.26 0 0 1 4.46 4.16 2.07 2.07 0 0 1 2.26 3.42"
                                    stroke="#0082cb"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="m322.61 177.03h23.6v2.83h-23.6z"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m324.85 176.93 7.57-25.7a2.25 2.25 0 0 1 4.16 0l7.29 25.7"
                                    stroke="#0082cb"
                                />
                                <path d="m329.79 161.4h9.42" stroke="#0082cb" />
                                <path
                                    d="m327.77 167.24h13.62"
                                    stroke="#0082cb"
                                />
                            </g>
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[3]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold"
                            v-html="carouselBodies[3]"
                        ></div>
                    </div>
                </div>
                <div
                    v-else-if="activeStep === 5"
                    :key="5"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            fill="none"
                            viewBox="0 0 513 254"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g stroke-width="3">
                                <path
                                    clip-rule="evenodd"
                                    d="m69.7501 141.71c30.2044 0 54.6899-24.485 54.6899-54.6899 0-30.2045-24.4855-54.69-54.6899-54.69-30.2045 0-54.69 24.4855-54.69 54.69 0 30.2049 24.4855 54.6899 54.69 54.6899z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m69.75 69.6399v182.9601"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m90.46 89.72c0 7.3989-3.9473 14.236-10.355 17.935-6.4077 3.7-14.3023 3.7-20.71 0-6.4077-3.699-10.355-10.5361-10.355-17.935"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m33.9801 214.89c13.3487 0 24.17-10.821 24.17-24.17s-10.8213-24.17-24.17-24.17c-13.3488 0-24.17004 10.821-24.17004 24.17s10.82124 24.17 24.17004 24.17z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path d="m33.98 181.2v71.15" stroke="#b0e7fb" />
                                <path
                                    d="m44.33 190.72c.1174 3.776-1.8302 7.317-5.0823 9.24-3.2522 1.923-7.2932 1.923-10.5453 0-3.2522-1.923-5.1998-5.464-5.0824-9.24"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m328.22 81.6101h23.92v23.92h-23.92z"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m340.17 81.6101v23.9099"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m354.52 105.52h-28.7"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m251.69 81.6101h23.92v23.92h-23.92z"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m285.17 81.6101h33.48v47.83h-33.48z"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m263.65 81.6101v23.9099"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m277.99 105.52h-28.69"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m328.22 30.2h23.92v23.92h-23.92z"
                                    stroke="#b0e7fb"
                                />
                                <path d="m340.17 30.2v23.91" stroke="#b0e7fb" />
                                <path
                                    d="m354.52 54.1101h-28.7"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m251.69 30.2h23.92v23.92h-23.92z"
                                    stroke="#b0e7fb"
                                />
                                <path d="m263.65 30.2v23.91" stroke="#b0e7fb" />
                                <path
                                    d="m277.99 54.1101h-28.69"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m289.95 30.2h23.92v23.92h-23.92z"
                                    stroke="#b0e7fb"
                                />
                                <path d="m301.91 30.2v23.91" stroke="#b0e7fb" />
                                <path
                                    d="m316.26 54.1101h-28.7"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m366.48 68.46h-129.14"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m378.43 1.5h-153.04"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m367.68 15.53h-131.54"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m237.34 1.5h129.14v127.94h-129.14z"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m294.74 105.64c.066 0 .12-.054.12-.12s-.054-.12-.12-.12-.12.054-.12.12.054.12.12.12z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m512.13 129.44h-407.33"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m512.13 252.35h-512.13"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m397.19 120.33h34.79"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m383.81 104.27c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m390.5 128.36c3.695 0 6.69-2.995 6.69-6.69s-2.995-6.69-6.69-6.69-6.69 2.995-6.69 6.69 2.995 6.69 6.69 6.69z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m390.5 123.01c.74 0 1.34-.6 1.34-1.34s-.6-1.34-1.34-1.34-1.34.6-1.34 1.34.6 1.34 1.34 1.34z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m438.67 123.01c.74 0 1.34-.6 1.34-1.34s-.6-1.34-1.34-1.34-1.34.6-1.34 1.34.6 1.34 1.34 1.34z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m438.67 128.36c3.695 0 6.69-2.995 6.69-6.69s-2.995-6.69-6.69-6.69-6.69 2.995-6.69 6.69 2.995 6.69 6.69 6.69z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m383.81 104.27c2.609.002 5.151-.824 7.26-2.36l7.93-5.7799c2.286-1.6661 5.042-2.5626 7.87-2.56h10.57c2.508-.015 4.969.6782 7.1 2 2.3 1.44 5.9 3.71 11 6.9999 1.916 1.223 4.059 2.049 6.3 2.43l6.47 1.07c2.931.49 5.076 3.029 5.07 6v2.93c-.005 2.953-2.397 5.345-5.35 5.35h-2.68"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m174.08 104.41c10.753 0 19.47-8.717 19.47-19.47s-8.717-19.47-19.47-19.47-19.47 8.717-19.47 19.47 8.717 19.47 19.47 19.47z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m174.08 84.9399v44.5001"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m165.74 84.9399c0 4.6061 3.734 8.34 8.34 8.34s8.34-3.7339 8.34-8.34"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m198.22 114.45c5.374 0 9.73-4.356 9.73-9.73 0-5.3737-4.356-9.73-9.73-9.73s-9.73 4.3563-9.73 9.73c0 5.374 4.356 9.73 9.73 9.73z"
                                    fill-rule="evenodd"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m198.22 107.19v22.25"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    d="m194.05 104.72c0 2.303 1.867 4.17 4.17 4.17s4.17-1.867 4.17-4.17"
                                    stroke="#b0e7fb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m311.2 215.92-7.19.54.67-182.1c-.168-1.3221.406-2.6292 1.494-3.3998 1.087-.7707 2.511-.8796 3.703-.2833 1.191.5964 1.958 1.8009 1.993 3.1331z"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m298.14 226.55 22-1.66"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m330.06 242.22c-5.46 10.25-33.62 15-47-.07 13.91-7.67 16.68-18.94 17.23-23.44.131-1.148 1.058-2.042 2.21-2.13l10.79-.82c.924-.065 1.804.4 2.27 1.2z"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m296.7 238.14c-1.887 3.52-4.564 6.556-7.82 8.87"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m301.44 243c-1.232 2.735-2.957 5.22-5.09 7.33"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m307.83 244.33c-.177 2.55-.772 5.053-1.76 7.41"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m320 237.23c2.044 3.233 3.339 6.882 3.79 10.68"
                                    stroke="#0082cb"
                                />
                                <path
                                    d="m314.33 240.81c1.068 3.219 1.469 6.621 1.18 10"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m373.54 38.73c2.808-3.0618 4.292-7.1089 4.13-11.26-.86-12.37-18-9.65-21.3-3.4s-2.93 22.09 1.37 23.21c1.72.44 5.37-.65 9.09-2.9l-2.33 16.62h13.78z"
                                    fill="#fff"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m387.14 112.01-21.71 71.17-10.51 60.53h-8.24l11.11-131.7z"
                                    fill="#fff"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m394.9 112c-1.47 39.08.26 59.23.59 62.78s4.85 26.57 15.55 70.11l-8.79-3c-16.9-39.92-22.66-60.68-24.6-65.92s-7.09-26.58-15.45-63.97z"
                                    fill="#fff"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m410.67 241c.678 1.473 1.107 3.047 1.27 4.66-.051 1.532-.225 3.056-.52 4.56h-32.49c-.853-2.8-.367-4.31 1.46-4.53 1.82-.22 3.33-.43 4.53-.61l15.47-6.91c.046-.02.099-.021.146-.002s.084.056.104.102l1.12 2.73c1.273.675 2.673 1.077 4.11 1.18 1.504-.155 2.959-.626 4.27-1.38.09-.048.195-.057.292-.025.096.032.175.103.218.195z"
                                    fill="#fff"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m356.45 241c.682 1.471 1.112 3.046 1.27 4.66-.052 1.531-.222 3.055-.51 4.56h-32.5c-.84-2.8-.35-4.31 1.47-4.53s3.33-.43 4.53-.61l15.46-6.91c.099-.043.215.002.26.1l1.12 2.73c1.269.676 2.666 1.078 4.1 1.18 1.507-.155 2.966-.625 4.28-1.38.09-.045.194-.053.29-.021s.175.101.22.191z"
                                    fill="#fff"
                                    fill-rule="evenodd"
                                    stroke="#0082cb"
                                />
                            </g>
                            <path
                                clip-rule="evenodd"
                                d="m327.89 58.8799-22.59-3.43c-3.875-2.3115-8.047-4.0844-12.4-5.27-1.07 0-2.78.31-.28 2.44s5 4.49 4.55 5.6-2.82.65-3.24 2.36c-.28 1.14 3.543 1.39 11.47.75l18.24 7.51zm7.26 37.78-16.37 15.9001c-4.185 1.695-8.12 3.949-11.7 6.7-.68.83-1.43 2.4 1.79 1.69s6.63-1.3 7.24-.26-1.18 2.64-.07 4c.753.907 3.26-1.983 7.52-8.67l17-10z"
                                fill="#fff"
                                fill-rule="evenodd"
                            />
                            <path
                                d="m327.89 58.8799 1.38.5887.76-1.781-1.915-.2907zm-22.59-3.43-.768 1.2882.252.1507.291.0441zm-12.4-5.27.394-1.4473-.193-.0527h-.201zm1.03 10.4 1.457.3578zm11.47.75.571-1.387-.333-.1371-.359.029zm18.24 7.51-.571 1.3871 1.369.5638.582-1.3622zm11.51 27.82 1.299-.7506-.963-1.6664-1.381 1.341zm-16.37 15.9001.563 1.39.272-.11.21-.204zm-11.7 6.7-.914-1.189-.137.105-.109.133zm8.96 5.43-1.162.948.008.011zm7.52-8.67-.761-1.293-.31.183-.194.304zm17-10 .761 1.293 1.283-.755-.745-1.289zm-12.445-48.6231-22.59-3.43-.45 2.966 22.59 3.43zm-22.047-3.2352c-3.991-2.3812-8.289-4.2077-12.774-5.4291l-.788 2.8946c4.222 1.1498 8.268 2.8692 12.026 5.1109zm-13.168-5.4818c-.324 0-.756.022-1.182.1197-.36.0827-1.056.2922-1.512.9222-.58.8014-.403 1.6985-.072 2.3219.308.5793.841 1.1449 1.513 1.718l1.946-2.2835c-.276-.2352-.471-.4262-.606-.5761-.137-.1532-.19-.2404-.204-.2656-.014-.0273.04.0606.044.2377.005.2045-.059.4244-.191.6063-.115.16-.237.2279-.27.2447-.034.0177-.034.0114.023-.0015.117-.027.3-.0438.511-.0438zm-1.253 5.0818c1.246 1.0612 2.426 2.1254 3.231 3.0353.408.4601.661.8162.787 1.0626.156.3048-.026.1453.115-.2032l2.78 1.1271c.366-.9035.04-1.7743-.224-2.2907-.294-.5748-.738-1.15-1.212-1.6849-.957-1.0802-2.277-2.2609-3.531-3.3297zm4.133 3.8947c.09-.2229.248-.2612.106-.1931-.184.0881-.371.136-.828.2909-.713.2415-2.168.7722-2.585 2.4679l2.914.7156c.003-.0142-.057-.1085.633-.342.244-.0826.76-.2347 1.16-.426.442-.2113 1.065-.6083 1.38-1.3862zm-3.307 2.5657c-.148.603-.007 1.2135.38 1.6898.327.4023.758.6229 1.089.7526.668.2623 1.561.3902 2.548.4547 2.026.1326 5.055.0269 9.031-.2941l-.242-2.9903c-3.95.319-6.797.4083-8.594.2908-.924-.0604-1.431-.1688-1.648-.2539-.112-.0442.004-.0251.144.1478.201.247.284.6003.206.9182zm12.356 2.4949 18.24 7.51 1.142-2.7741-18.24-7.51zm20.191 6.7116 4.25-9.96-2.76-1.1774-4.25 9.96zm9.085 26.1553-16.37 15.9001 2.09 2.152 16.37-15.9001zm-15.888 15.5861c-4.31 1.745-8.364 4.067-12.051 6.901l1.828 2.378c3.472-2.669 7.29-4.855 11.349-6.499zm-12.297 7.139c-.221.269-.478.633-.664 1.041-.16.349-.412 1.038-.173 1.788.299.936 1.118 1.332 1.813 1.445.651.105 1.428.023 2.297-.168l-.646-2.93c-.355.078-.626.119-.828.135-.207.017-.311.007-.343.001-.033-.005.063.004.201.102.16.113.297.29.365.504.06.189.042.33.035.373-.008.044-.014.045.007-.002.045-.098.137-.241.256-.387zm3.273 4.106c1.607-.355 3.176-.659 4.395-.756.616-.049 1.055-.037 1.327.01.337.06.094.109-.099-.22l2.588-1.518c-.498-.849-1.397-1.116-1.971-1.217-.639-.111-1.369-.103-2.084-.046-1.443.116-3.189.462-4.802.817zm5.623-.966c-.117-.199-.054-.34-.085-.186-.041.2-.115.378-.267.834-.237.713-.689 2.19.414 3.541l2.324-1.897c-.007-.008-.119-.011.109-.698.081-.244.271-.746.359-1.181.098-.481.156-1.212-.266-1.931zm.07 4.2c.395.475.965.724 1.572.702.516-.018.951-.226 1.255-.411.616-.375 1.258-1.008 1.905-1.755 1.33-1.533 3.07-4.005 5.207-7.359l-2.53-1.612c-2.123 3.332-3.766 5.648-4.943 7.006-.606.698-.998 1.035-1.198 1.157-.103.062-.02-.016.197-.024.309-.011.636.129.843.378zm9.435-8.336 17-10-1.522-2.586-17 10zm17.538-12.044-5.41-9.3597-2.598 1.5013 5.41 9.3604z"
                                fill="#0082cb"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m358 56.9301c-7.34 19.84-19.71 36-38.47 53.6199l9.13 7.74c22-11.87 33.58-18.7899 37.16-37.0599.89-4.58 0-18.67-.13-26.13z"
                                fill="#fff"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m394.86 114.75-44 6.19c5.713-31.6866 7.883-53.1899 6.51-64.5099-.07-.58.86-1.74 1.35-1.68 3.842.4334 7.713-.5052 10.93-2.65 12.77 15.25 19.27 35.33 25.21 62.6499z"
                                fill="#fff"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m365.84 52.6699c-12.61 1.87-32.76 7-57.43 2.81l-.71 11.93c19.46 8.92 38.77 15.24 54.43 11.76-2.75 30.3301.95 54.3301 16.13 52.2001l23.48-3.3c.22-25.47-14.44-58.6901-26-74.8701-.634-1.0786-1.849-1.6764-3.09-1.52l-6.83 1z"
                                fill="#fff"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m358.7 23.1399s5.58 4.47 5.58 6.51c0 0 5-3 5 0-.112 1.9152-.97 3.7103-2.39 5l6.63 4"
                                fill="#fff"
                                fill-rule="evenodd"
                            />
                            <path
                                d="m358.7 23.1399s5.58 4.47 5.58 6.51c0 0 5-3 5 0-.112 1.9152-.97 3.7103-2.39 5l6.63 4"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                d="m157.5 251.8c-.18-6.73 6.24-12.87 12.94-12.39.76-5.61 8.51-8.79 13-5.34-.21-4.73.24-9.95 3.59-13.3s10.37-2.85 11.6 1.72c1.147-3.693 4.965-5.86 8.724-4.95 3.758.909 6.164 4.581 5.496 8.39 2.63-2.23 5.81-4.15 9.26-4.05s7 2.92 6.71 6.36c.842-1.882 2.699-3.106 4.761-3.136 2.061-.03 3.954 1.138 4.85 2.995.897 1.857.635 4.065-.671 5.661 2.844-1.417 6.268-.92 8.593 1.246 2.324 2.166 3.06 5.547 1.847 8.484 2.145-.941 4.656-.21 5.962 1.735s1.031 4.546-.652 6.175"
                                stroke="#0082cb"
                                stroke-linejoin="round"
                                stroke-width="3"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m131.62 244.67c-.54-2.63.07-6.11 5.26-7.9 5.68-2 12.93 1.2 14.69 1.8-.93 1.38-5.07 8.6-10.75 10.56-5.22 1.8-7.8-.65-8.76-3.06-.181-.455-.328-.923-.44-1.4z"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-linejoin="round"
                                stroke-width="3"
                            />
                            <path
                                d="m142.23 241.63c-5.49-.66-7.15 2.05-10.62 3.69"
                                stroke="#0082cb"
                                stroke-linejoin="round"
                                stroke-width="3"
                            />
                            <path
                                d="m131.61 245.32c-1.435.796-3.024 1.277-4.66 1.41"
                                stroke="#0082cb"
                                stroke-linejoin="round"
                                stroke-width="3"
                            />
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[4]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold"
                            v-html="carouselBodies[4]"
                        ></div>
                    </div>
                </div>
                <div
                    v-else-if="activeStep === 6"
                    :key="6"
                    class="flex flex-col md:flex-row items-start"
                >
                    <div class="order-2 md:order-1 w-full md:w-1/2 md:px-6">
                        <svg
                            class="w-full block"
                            fill="none"
                            viewBox="0 0 513 183"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g stroke="#0082cb">
                                <path
                                    clip-rule="evenodd"
                                    d="m283.5 181.31h-66.34c-2.274.003-4.173-1.734-4.37-4l-8.41-100.9999h91.9l-8.42 100.9999c-.197 2.262-2.09 3.998-4.36 4z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    d="m195.62 76.29h109.41"
                                    stroke-width="3"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m274.4 76.2899h-48.14l6.15-9.24c1.625-2.4303 4.356-3.8895 7.28-3.89h21.31c2.925-.003 5.657 1.457 7.28 3.89z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m156.24 181.31h-74.4c-1.1598.003-2.2729-.457-3.093-1.277s-1.2797-1.933-1.277-3.093v-100.65h83.14v100.65c0 2.414-1.957 4.37-4.37 4.37z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    d="m68.71 76.29h100.66"
                                    stroke-width="3"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m138.73 76.2899h-39.38v-8.76c0-2.4135 1.956-4.37 4.37-4.37h30.64c1.159 0 2.27.4604 3.09 1.28.82.8195 1.28 1.931 1.28 3.09z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m428.38 181.31h-74.38c-2.413 0-4.37-1.956-4.37-4.37v-100.65h83.15v100.65c0 1.164-.464 2.28-1.291 3.101-.826.82-1.945 1.277-3.109 1.269z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    d="m340.86 76.29h100.65"
                                    stroke-width="3"
                                />
                                <path
                                    clip-rule="evenodd"
                                    d="m410.88 76.2899h-39.39v-8.76c.006-2.4151 1.965-4.37 4.38-4.37h30.63c2.415 0 4.374 1.9549 4.38 4.37z"
                                    fill-rule="evenodd"
                                    stroke-width="3"
                                />
                                <path
                                    d="m512.13 181.31h-512.13"
                                    stroke-width="3"
                                />
                                <path
                                    d="m92.3 24.6001 10.77 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m147.06 24.6001-10.78 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m119.33 28.93v-17.14"
                                    stroke-width="3"
                                />
                                <path
                                    d="m221.94 16.3401 10.77 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m276.7 16.3401-10.77 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m248.98 20.67v-17.13997"
                                    stroke-width="3"
                                />
                                <path
                                    d="m363.8 12.8101 10.78 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m418.56 12.8101-10.77 10.77"
                                    stroke-width="3"
                                />
                                <path
                                    d="m390.84 17.14v-17.14"
                                    stroke-width="3"
                                />
                                <path
                                    d="m112.93 129.95 22.1 11"
                                    stroke-width="3"
                                />
                            </g>
                            <path
                                clip-rule="evenodd"
                                d="m242.9 122.07-2.36-1.48 1.46-2.37c1.46-2.32 2.91-4.65 4.38-7 .695-1.221 1.858-2.106 3.22-2.45 1.112-.325 2.313-.099 3.23.61.914.711 1.728 1.541 2.42 2.47 1.16 1.65 2.15 3.42 3.24 5.18l2.36-1-.68 1.79c-.33.87-.65 1.76-1 2.62-.08.18-.37.43-.54.41-1.54-.19-3.07-.45-4.8-.71l2.27-1.58-1.84-3-1.66-2.72c-1.05-1.75-2.76-1.77-3.86 0-1.76 2.813-3.513 5.623-5.26 8.43z"
                                fill="#0082cb"
                                fill-rule="evenodd"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m251.75 136.9 3.25-4.08.24 2.67c.13.041.264.068.4.08 2.26 0 4.51-.07 6.76-.16.728-.014 1.391-.424 1.73-1.069.339-.644.301-1.423-.1-2.031-.77-1.52-1.59-3-2.39-4.52l-2.85-5.38 2.42-1.3c.12.18.24.34.33.5 1.58 2.967 3.157 5.937 4.73 8.91.846 1.338 1.062 2.979.59 4.49-.73 2.09-2.49 2.83-4.44 3.07s-3.9.2-5.85.28l-1.25.06-.32 2.58z"
                                fill="#0082cb"
                                fill-rule="evenodd"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m250.58 135.56v2.81h-5.08c-2.21 0-4.42.08-6.61-.1-3.15-.26-4.82-2.64-4.12-5.73.239-.955.574-1.883 1-2.77.73-1.59 1.54-3.14 2.34-4.76l-2.11-1.44c1.7-.33 3.25-.64 4.82-.92.196.018.373.125.48.29.64 1.41 1.26 2.83 1.95 4.41l-2.56-1.08-1.16 2.3c-.65 1.28-1.28 2.56-1.92 3.85-.472.657-.502 1.534-.075 2.222.427.687 1.227 1.05 2.025.918h10.4z"
                                fill="#0082cb"
                                fill-rule="evenodd"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m399 141.16h-18.31c-.286 0-.561-.114-.764-.316-.202-.203-.316-.477-.316-.764v-24.74h20.44v24.74c.006.587-.463 1.069-1.05 1.08z"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                d="m377.01 113.9 24.18-5.26"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m393.83 110.24-9.46 2.06-.46-2.1c-.062-.279-.011-.57.143-.811.154-.24.398-.409.677-.469l7.36-1.61c.583-.123 1.155.248 1.28.83z"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                d="m389.83 119.64v17.22"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                d="m394.67 119.64v17.22"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                d="m384.99 119.64v17.22"
                                stroke="#0082cb"
                                stroke-width="2"
                            />
                            <path
                                clip-rule="evenodd"
                                d="m125.495 136.208c1.75-3.515-2.459-9.166-9.401-12.621s-13.988-3.406-15.737.109c-1.7502 3.516 2.459 9.166 9.401 12.621s13.987 3.406 15.737-.109z"
                                fill-rule="evenodd"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                d="m77.47 85.1899h83.14"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                d="m349.61 85.1899h83.15"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                            <path
                                d="m204.4 85.1899h92.15"
                                stroke="#0082cb"
                                stroke-width="3"
                            />
                        </svg>
                    </div>
                    <div
                        class="order-1 md:order-2 w-full md:w-1/2 md:px-6 text-center md:text-left mb-12 md:mb-0"
                    >
                        <h5
                            class="text-teal-darker font-semibold md:font-normal text-xl md:text-3xl mb-6 leading-none"
                            v-html="carouselTitles[5]"
                        ></h5>
                        <div
                            class="how-to-clean-a-drain-carousel-body text-lg leading-normal font-semibold"
                            v-html="carouselBodies[5]"
                        ></div>
                    </div>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        carouselTitles: null,
        carouselBodies: null,
    },

    data() {
        return {
            activeStep: 1,
        };
    },
};
</script>

<style>
.how-to-clean-a-drain-carousel-body p {
    margin-bottom: 1.5em;
}
</style>
